import { employeeStore, userStore } from '../../stores';
import { EmployeeController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import { useNavigate } from 'react-router-dom';
import { ViewDepartments } from '../../pages';
import constant from '../../utils/constant';
import { array, object, string } from 'yup';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const ViewDepartmentsContainer = ({ closeModal, setShowSurvey }) => {
	const [createDepartment, setCreateDepartment] = useState(false);
	const [deptDetails, setDeptDetails] = useState(false);
	const [loading, setLoading] = useState(false);
	const [createUnit, setCreateUnit] = useState(false);

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.EMPLOYEEADDDEPARTMENT);

	const goBack = () => {
		if (createUnit && deptDetails) {
			setCreateUnit(false);
		} else if (createDepartment) {
			setCreateDepartment(false);
		} else if (deptDetails) {
			setDeptDetails(false);
		} else {
			closeModal();
		}
	};

	const navigate = useNavigate();

	const isOnboardingDone = () => {
		if (userStore.isOnBoardingDone === 'false') {
			MimaToastUtil.error({
				message: constant.OnboardingRequired,
			});
			localStorage.setItem(constant.RoutePath, constant.Routes.Employees);
			return navigate(constant.Routes.OnboardingStageOne);
		}
	};
	const showCreateDepartment = () => {
		// isOnboardingDone();
		setCreateDepartment(true);
	};
	const showDeptDetails = () => {
		setDeptDetails(true);
	};

	const showCreateUnit = () => {
		setCreateUnit(true);
	};

	const validationSchema = () => {
		return object({
			depts: array(
				object({
					name: string().required('Department name is required'),
				})
			),
		});
	};

	const unitValidationSchema = () => {
		return object({
			units: array(
				object({
					name: string().required('Department name is required'),
				})
			),
		});
	};

	const onSubmit = async payload => {
		setLoading(true);
		const { status, errorMessage } = await EmployeeController.createDepartments(
			payload
		);

		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			 closeModal();
			 if (needFeedback._id) {
				setShowSurvey(true)
				userStore.setReviewId(needFeedback._id)
			}
			return;
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	const onSubmitUnit = async payload => {
		setLoading(true);
		const { status, errorMessage } = await EmployeeController.createUnits(
			payload
		);

		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	const deptNames = employeeStore.departments;

	return (
		<ViewDepartments
			closeModal={closeModal}
			loading={loading}
			employees={employeeStore.mappedEmployees}
			createDepartment={createDepartment}
			showCreateDepartment={showCreateDepartment}
			deptDetails={deptDetails}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
			showDeptDetails={showDeptDetails}
			deptNames={deptNames}
			goBack={goBack}
			showCreateUnit={showCreateUnit}
			createUnit={createUnit}
			onSubmitUnit={onSubmitUnit}
			unitValidationSchema={unitValidationSchema}
		/>
	);
};

export default observer(ViewDepartmentsContainer);
